module.exports = __webpack_public_path__ + "static/media/background.7b1e94b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/background.jpg
// module id = 313
// module chunks = 0